//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { ExportPackageMessage, ProjectModel } from "@app/catalog";
import { Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: ProjectModel,
  key: "tileBottom",
})
@Component({
  selector: 'project-carousel-item-bottom',
  standalone: false,
  templateUrl: './project-carousel-item-bottom.component.html',
  styleUrl: './project-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCarouselItemBottomComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public data: WritableSignal<ProjectModel> = signal<ProjectModel>(undefined);


  constructor(
    private messenger: Messenger,
  ) {}

  public navigateToDetailPage() {
    this.router.navigate(["project", this.data().id], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
    });
  }

  public openExportPackage(){
    this.messenger.send(new ExportPackageMessage(this.data()));
  }
}
